import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@resmed/identity-spa-auth-react';
import { FormWrapper } from 'components/pages/common/FormWrapper';
import { useForm } from 'hooks/hooks';
import { ActionButtons } from 'components/common/ActionButtons';
import { useToast } from 'components/toasts/useToast';
import { EmailField, emailRegex, MIN_EMAIL_LENGTH } from 'components/pages/security/email/EmailField';
import { PasswordField, MIN_PASSWORD_LENGTH, MAX_PASSWORD_LENGTH } from 'components/pages/security/password/PasswordField';
import { routes } from 'routes/routes';
import { logger } from 'utils/logger';
export const CreateAccount = () => {
    const { formValues, handleChange } = useForm({
        firstName: { label: 'First name', value: '' },
        lastName: { label: 'Last name', value: '' },
        email: { label: 'Email address', value: '' },
        password: { label: 'Password', value: '' },
        confirmPassword: { label: 'Confirm password', value: '' }
    });
    const { showToast } = useToast();
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();
    useEffect(() => {
        if (isAuthenticated) {
            logger.info('CreateAccount: user already authenticated, redirecting to overview');
            navigate(routes.OVERVIEW, { replace: true });
        }
    }, [isAuthenticated, navigate]);
    const isSaveDisabled = () => {
        const firstName = formValues.firstName.value.trim();
        const lastName = formValues.lastName.value.trim();
        const email = formValues.email.value.trim();
        const password = formValues.password.value;
        const confirmPassword = formValues.confirmPassword.value;
        if (!firstName || !lastName) {
            return true;
        }
        if (email.length < MIN_EMAIL_LENGTH || !emailRegex.test(email)) {
            return true;
        }
        if (!password ||
            !confirmPassword ||
            password !== confirmPassword ||
            password.length < MIN_PASSWORD_LENGTH ||
            password.length > MAX_PASSWORD_LENGTH) {
            return true;
        }
        return false;
    };
    const handleSave = () => {
        showToast('Account creation is not yet implemented. Backend integration pending.', 'info');
        logger.info('CreateAccount: submit clicked with valid form; backend integration pending');
    };
    const handleCancel = () => {
        logger.info('CreateAccount: user cancelled account creation, navigating back');
        // Use browser-style back navigation so deep links return users to their origin.
        navigate(-1);
    };
    return (_jsx(Box, { sx: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', px: 2 }, children: _jsxs(FormWrapper, { maxWidth: 540, children: [_jsx(Typography, { variant: "h1", children: "Create a Resmed account" }), _jsx(Typography, { variant: "body1", children: "Enter your details below to create a new Resmed account." }), _jsx(TextField, { label: formValues.firstName.label, value: formValues.firstName.value, onChange: (event) => handleChange('firstName', event.target.value), fullWidth: true }), _jsx(TextField, { label: formValues.lastName.label, value: formValues.lastName.value, onChange: (event) => handleChange('lastName', event.target.value), fullWidth: true }), _jsx(EmailField, { fieldName: formValues.email.label, value: formValues.email.value, onChange: (event) => handleChange('email', event.target.value) }), _jsx(PasswordField, { fieldName: formValues.password.label, value: formValues.password.value, onChange: (event) => handleChange('password', event.target.value) }), _jsx(PasswordField, { fieldName: formValues.confirmPassword.label, value: formValues.confirmPassword.value, onChange: (event) => handleChange('confirmPassword', event.target.value) }), _jsx(ActionButtons, { disableSave: isSaveDisabled(), onSave: handleSave, onCancel: handleCancel })] }) }));
};
